/**
 * The assumed number of characters (including spaces) per standard page in a
 * text feed.
 */
const CHARACTERS_PER_STANDARD_PAGE = 2400;

/**
 * Calculate the standard page count for the given input text (please note that
 * the text is assumed to be a raw text string).
 */
export function getStandardPageCount(text: string): number {
    return text.length / CHARACTERS_PER_STANDARD_PAGE;
}
